export const API_HOST = "spoonacular-recipe-food-nutrition-v1.p.rapidapi.com";
export const API_KEY = process.env.REACT_APP_API_KEY;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

export const RECIPES_IMAGES = "https://spoonacular.com/recipeImages/";

export const MY_SERVER_URL = "http://localhost:5000/myrecipes";
